export default function parseStringifiedJson(data: string) {
  try {
    return JSON.parse(data);
  } catch (error) {
    return null;
  }
}
